// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"278":"infobox","522":"Debugger","663":"credits"}[chunkId] || chunkId) + "-legacy." + {"22":"3b1583a4","278":"b42d31f5","522":"4b14211c","652":"ca376c2f","663":"1016f72e"}[chunkId] + ".js";
};